import styled from 'styled-components';
export const SQLCardContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.white_1};
  padding: ${({ theme }) => theme.spacing.md}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_2};
  border-radius: ${({ theme }) => theme.border_radius.sm};
`;
export const SQLCardTitle = styled.div `
  margin-bottom: ${({ theme }) => theme.spacing.sm}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const SQLTableList = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm}px;
  max-height: 300px;
  overflow-y: auto;
`;
export const SQLTableItem = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  padding: ${({ theme }) => theme.spacing.xs}px
    ${({ theme }) => theme.spacing.sm}px;
  background-color: ${({ theme }) => theme.colors.grey_5};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
`;
export const SQLTableName = styled.span `
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
export const SQLResultsTable = styled.table `
  width: 100%;
  border-collapse: collapse;
  font-size: ${({ theme }) => theme.fonts.body4};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
`;
export const SQLResultsHeader = styled.th `
  padding: ${({ theme }) => theme.spacing.xs}px
    ${({ theme }) => theme.spacing.sm}px;
  text-align: left;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  background-color: ${({ theme }) => theme.colors.grey_5};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
  font-family: monospace;
  font-size: ${({ theme }) => theme.fonts.overline};
  white-space: nowrap;
`;
export const SQLResultsRow = styled.tr `
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.grey_5};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.beige_1};
  }
`;
export const SQLResultsCell = styled.td `
  padding: ${({ theme }) => theme.spacing.xs}px
    ${({ theme }) => theme.spacing.sm}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_5};
  font-size: ${({ theme }) => theme.fonts.overline};
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
